import { render } from "./ClubCard.vue?vue&type=template&id=85be1918&scoped=true"
import script from "./ClubCard.vue?vue&type=script&lang=js"
export * from "./ClubCard.vue?vue&type=script&lang=js"

import "./ClubCard.vue?vue&type=style&index=0&id=85be1918&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85be1918"]])

export default __exports__